import { render, staticRenderFns } from "./RentalInfo.vue?vue&type=template&id=2b37298e&scoped=true"
import script from "./RentalInfo.vue?vue&type=script&lang=js"
export * from "./RentalInfo.vue?vue&type=script&lang=js"
import style0 from "./RentalInfo.vue?vue&type=style&index=0&id=2b37298e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b37298e",
  null
  
)

export default component.exports